var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"newton-button",attrs:{"rounded":"","depressed":""},on:{"click":_vm.openAssistant}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(" mdi-star-four-points ")]),_vm._v(" Newton AI ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }